.chevron-icon-container {
    color: var(--grey-dk);
    transform: rotate(-90deg);
    transition: transform 0.1s ease-in-out;
}

.chevron-icon-container--rotate {
    transform: rotate(0deg);
}
